import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  border: {
    border: '1px solid #C4C4C4',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(6),
  },
  separator: {
    border: 0,
    borderBottom: '1px solid #C4C4C4',
  },
  title: {
    ...theme.typography.h4,
    fontSize: 32,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  fieldLabel: {
    color: '#AAA',
    fontSize: 16,
  },
  fieldValue: {
    fontSize: 18,
    fontWeight: 'bold',
    maxHeight: '8em',
    overflowY: 'auto',
    wordBreak: 'break-word',
  },
}));

interface Props {
  loanData: {
    loanId?: number | string;
    fileNumber?: string;
    borrowerNames?: string[];
    propertyAddresses?: string[];
    loanAmount?: number | string;
    scheduledClosingDate?: string;
    closingAttorney?: string;
    titleCompany?: string;
  };
}

const formatCurrency = (value?: number | string) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const amount = typeof value === 'string' ? Number(value) : value;
  if (isNaN(amount as number)) {
    return String(value);
  }
  return (amount as number).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

export const WireInstructionsLoanDetailsCard = ({ loanData }: Props) => {
  const classes = useStyles();

  const borrowerNames = loanData?.borrowerNames ?? [];
  const propertyAddresses = loanData?.propertyAddresses ?? [];

  return (
    <Box className={classes.border}>
      <Typography className={classes.title}>Loan &amp; Closing Details</Typography>
      <Box py={2}>
        <hr className={classes.separator} />
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>Lender Loan / File Number:</Typography>
        <Typography className={classes.fieldValue}>
          {loanData?.loanId}
        </Typography>
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>
          {borrowerNames.length > 1 ? 'Borrower Names:' : 'Borrower Name:'}
        </Typography>
        <Typography className={classes.fieldValue}>
          {borrowerNames.map(name => (
            <div key={name}>{name}</div>
          ))}
        </Typography>
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>
          {propertyAddresses.length > 1 ? 'Property Addresses:' : 'Property Address:'}
        </Typography>
        <Typography className={classes.fieldValue}>
          {propertyAddresses.map(addr => (
            <div key={addr}>{addr}</div>
          ))}
        </Typography>
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>Loan Amount:</Typography>
        <Typography className={classes.fieldValue}>
          {formatCurrency(loanData?.loanAmount)}
        </Typography>
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>Scheduled Closing Date:</Typography>
        <Typography className={classes.fieldValue}>
          {loanData?.scheduledClosingDate}
        </Typography>
      </Box>

      <Box className={classes.field}>
        <Typography className={classes.fieldLabel}>Closing Attorney:</Typography>
        <Typography className={classes.fieldValue}>
          {loanData?.closingAttorney}
        </Typography>
      </Box>

      <Box>
        <Typography className={classes.fieldLabel}>Title Company:</Typography>
        <Typography className={classes.fieldValue}>
          {loanData?.titleCompany}
        </Typography>
      </Box>
    </Box>
  );
};
